import { render, staticRenderFns } from "./CreateRevision.vue?vue&type=template&id=6d8ee5b6&scoped=true&"
import script from "./CreateRevision.vue?vue&type=script&lang=js&"
export * from "./CreateRevision.vue?vue&type=script&lang=js&"
import style0 from "./CreateRevision.vue?vue&type=style&index=0&id=6d8ee5b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ee5b6",
  null
  
)

export default component.exports